import { addColumns } from '@nozbe/watermelondb/Schema/migrations'

export default {
  toVersion: 22,
  steps: [
    addColumns({
      table: 'chats',
      columns: [{ name: 'department', type: 'string', isOptional: true }]
    })
  ]
}
